<template>
    <div id="createDhlShipmentId">
        <a-modal v-model="visible" :footer="null" :title="$t('soPage.labelAddOrderToShipmentId')" width="40%">
            <a-form :form="form01">

                <a-row>
                    <a-col span="2" offset="1">
                        <a-form-item class="genericFrom">
                            <a-row>
                                <a-button class="fonterButton" type="primary" size="small" @click="doQuery">{{ $t('soPage.labelQuery') }}</a-button>
                            </a-row>
                        </a-form-item>
                    </a-col>

                    <a-col span="2" offset="1">
                        <a-form-item class="genericFrom">
                            <a-row>
                                <a-button class="fonterButton" type="primary" size="small" @click="doSubmit">{{ $t('soPage.labelConfirm') }}</a-button>
                            </a-row>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row>
                    <a-col span="6" offset="1">
                        <a-form-item class="genericFrom">
                            <b>{{ $t('soPage.labelShipmentReference') }}:</b>
                            <a-input size="small" v-model="shipmentReference"></a-input>
                        </a-form-item>
                    </a-col>

                    <!--
                    <a-col span="3" offset="1">
                        <a-form-item class="genericFrom">
                            <a-row><b> </b><br/></a-row>
                            <a-row>
                                <a-button class="fonterButton" type="primary" size="small" @click="doSubmit">{{ $t('soPage.labelConfirm') }}123</a-button>
                            </a-row>
                        </a-form-item>
                    </a-col>
                    -->

                </a-row>


            </a-form>



            <a-row>
                <vxe-table
                        border
                        resizable
                        column-key
                        highlight-hover-column
                        highlight-hover-row
                        highlightCurrentRow
                        show-header-overflow
                        show-overflow
                        :sort-config="{multiple: true, trigger: 'cell'}"
                        :edit-config="{trigger: 'click', mode: 'cell', showStatus: true}"
                        :checkbox-config="{trigger:'row',highlight:false,range:true}"
                        keep-source
                        :keyboard-config="{isArrow: true}"
                        align="center"
                        :data.sync="pickLocationList"
                        class="mytable-style"
                        :height="250"
                        ref="refPickLocationGrid"
                        size="mini">
                    <template v-slot:empty>
                    </template>
                    <vxe-table-column type="checkbox" width="35"></vxe-table-column>
                    <vxe-table-column field="shipment_reference" :title="$t('soPage.labelShipmentReference')" sortable></vxe-table-column>
                </vxe-table>
            </a-row>

            <!-- pagination -->
            <a-row>
                <a-col align="left" style="border: 1px solid #e8eaec;padding: 5px;left: 0;bottom: 0;">
                    <a-pagination
                            :pageSizeOptions="page.pageSizeOptions"
                            :showTotal="total => $t('job.Total') + ` ${page.pagingTotal} `+$t('job.Records')"
                            size="small"
                            :total="page.pagingTotal"
                            v-model="page.currentVal"
                            :pageSize.sync="page.pagingSize"
                            @change="tableChangePage"
                            @showSizeChange="onShowSizeChange"
                            showSizeChanger
                            :showQuickJumper="false"
                    />
                </a-col>
            </a-row>



        </a-modal>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'

    export default {
        data() {
            return {
                // 列表数据
                pickLocationList: [],
                // 分页
                page: {
                    pageSizeOptions: ['10', '20', '30', '40', '100', '200', '500', '1000'],
                    pagingTotal: 10,
                    currentVal: 1,
                    pagingSize: 20
                },

                visible: false,
                orderNo: "",
                orderUids: [],
                form01: this.$form.createForm(this),
                shipmentReference: "",

            }
        },

        methods: {
            // init
            show(orderUids) {
                //this.orderNo = orderNo;
                this.orderUids = orderUids;
                this.visible = true;
                this.form01.resetFields();
                this.shipmentReference = "";

                this.doQuery();

            },

            init() {

               this.doQuery();

            },

            // 分页
            tableChangePage(current) {
                this.page.currentVal = current;
                this.init();
            },

            // 选择条数
            onShowSizeChange(current, pageSize) {
                this.page.currentVal = current;
                this.page.pagingSize = pageSize;
                this.init();
            },

            doQuery() {
                this.form01.validateFields((err, val) => {
                    if (!err) {
                        let shipmentReference = this.shipmentReference;
                        /*
                        if (shipmentReference == undefined || shipmentReference == null || shipmentReference.trim() == '') {
                            this.$customMessage.warning(this.$t('soPage.msgShipmentReferenceIsNull'));
                            return;
                        }
                        */

                        let params = new FormData();
                        params.append("pageNum", this.page.currentVal);
                        params.append("pageSize", this.page.pagingSize);
                        params.append("shipmentReference", shipmentReference);

                        ajax.post(api.FIND_SHIPMENT_REFERENCE, params).then(res => {
                            if (res.code == 200) {
                                if (res.data) {
                                    this.pickLocationList = res.data;
                                    this.page.pagingTotal = res.total;
                                }
                            } else {
                                this.$customMessage.error(res.msg);
                            }
                        });

                    }
                });
            },

            doSubmit() {
                this.form01.validateFields((err, val) => {
                    if (!err) {

                        let records = this.$refs.refPickLocationGrid.getCheckboxRecords();
                        if (records.length != 1) {
                            this.$customMessage.warning(this.$t('publicLang.pleaseOneOnly'), 3)
                            return;
                        }

                        let shipmentReferenceList = [];
                        for(let t in records){
                            shipmentReferenceList.push(records[t].shipment_reference);
                        }

                        // params
                        let params = new FormData();
                        params.append("orderUids", this.orderUids);
                        params.append("shipmentReference", shipmentReferenceList[0]);

                        // POST
                        ajax.post(api.ADD_ORDER_TO_SHIPMENT_ID, params).then(res => {
                            if (res.code == 200) {
                                this.$message.success(this.$t('cfs.operationSuccess'));
                                this.form01.resetFields();
                                this.visible = false;
                            } else {
                                this.$customMessage.error(res.msg);
                            }
                        });

                    }
                });
            },

            cancel() {
                this.form01.resetFields();
                this.visible = false;
            },

        }
    }
</script>